import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { Trans } from '@lingui/react/macro'
import { entityParams } from '@pkg/db/utils'
import { createFileRoute } from '@tanstack/react-router'
import { SignedDocumentTab } from './-tabs/signed'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_documents/unterschriftsdokumente/versorgungsauftrag')({
  component: RouteComponent,
  params: entityParams({ id: PatientId }),
})

function RouteComponent() {
  const { id: patientId } = Route.useParams()

  return (
    <SignedDocumentTab
      id={patientId}
      type="PatientSupply"
      findingIds={['FormsPatientSupplyRequired']}
      to="/patienten/$id/versorgungsauftrag/$form"
      title={<Trans>Versorgungsauftrag</Trans>}
      createButtonText={<Trans>Versorgungsauftrag erstellen</Trans>}
    />
  )
}
